<template>
    <!-- 内容区 -->
    <div class="news">
        <!-- banner -->
        <div class="banner-home banner-small">
            <div class="container">
                <img src="../assets/images/title-news.svg" class="banner-title">
            </div>
        </div>
        <div class="container">
            <div class="wrap">
                <router-link class="card" :to="{name: 'NewsDetail', params: {id: item.article_id}}" v-for="item in articleList" :key="item.article_id">
                    <div class="card-pic">
                        <img :src="item.cover">
                    </div>
                    <div class="card-body">
                        <div class="card-title">{{item.title}}</div>
                        <div class="card-des">
                            <div class="card-date">{{item.created_at}}</div>
                            <div class="btn-link">查看详情 <i class="iconfont icon-more"></i></div>
                        </div>
                    </div>
                </router-link>
            </div>
            <!-- 分页 -->
            <nav v-if="totalPage > 1">
                <ul class="pagination  pagination-lg justify-content-center">
                    <li class="page-item" :class="[ curPage == 1 ? 'disabled': '']">
                        <a class="page-link" @click="reducePage" tabindex="-1" aria-disabled="true"><i class="iconfont icon-arrow-left"></i></a>
                    </li>
                    <li class="page-item" :class="[ page==curPage ? 'active':'' ]" v-for="page in totalPage" :key="page"><a class="page-link" @click="changePage(page)">{{page}}</a></li>
                    <li class="page-item"  :class="[ curPage == totalPage ? 'disabled': '']">
                        <a class="page-link" @click="addPage" aria-disabled="true"><i class="iconfont icon-arrow-right"></i></a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { articleList } from "@/network/API.js";
export default {
  data() {
    return {
      articleList: [],
      curPage: 1,
      totalPage: 0
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      articleList({
        page_size: 10,
        page: this.curPage,
        code: "news"
      }).then(res => {
        this.articleList = res.list;
        let tPage = parseInt(res.total)
        this.totalPage = tPage % 10 == 0 ? tPage / 10 : parseInt(tPage / 10) + 1
      });
    },
    reducePage(){
        this.curPage -= 1
        this.loadList()
    },
    addPage(){
        this.curPage += 1
        this.loadList()
    },
    changePage(page){
        console.log('current page is ',page);
        this.curPage = page
        this.loadList()
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/newsList.vue